module.exports = __webpack_public_path__ + "static/media/cases_3d_keslon_03b.463a4793.jpg";